import type { ReactNode } from 'react'
import clsx from 'clsx'

interface Props {
  label: string
  children: ReactNode
  className?: string
}

export default function DataRow({ label, children, className }: Props) {
  return (
    <div
      className={clsx(
        'flex items-baseline py-1.5 border-b border-gray-100 last:border-b-0 text-[0.84rem]',
        'max-sm:flex-col max-sm:items-stretch max-sm:gap-0.5',
        className,
      )}
    >
      <div className="flex-[0_0_140px] max-sm:flex-none text-gray-500 text-[0.76rem] font-medium">
        {label}
      </div>
      <div className="flex-1 font-medium text-gray-900">{children}</div>
    </div>
  )
}
